import React from "react";

function UpcomingSvgComponent(props: any) {
  return (
    <div>
      <svg
        id="upcoming_black_24dp"
        xmlns="http://www.w3.org/2000/svg"
        width="24"
        height="24"
        viewBox="0 0 24 24"
      >
        <g id="Group_8571" data-name="Group 8571">
          <rect
            id="Rectangle_14180"
            data-name="Rectangle 14180"
            width="24"
            height="24"
            fill="none"
          />
        </g>
        <g id="Group_8572" data-name="Group 8572">
          <path
            id="Path_40080"
            data-name="Path 40080"
            d="M17.6,10.81,16.19,9.4l3.56-3.55,1.41,1.41C21.05,7.29,17.6,10.81,17.6,10.81ZM13,3H11V8h2ZM6.4,10.81,7.81,9.4,4.26,5.84,2.84,7.26C2.95,7.29,6.4,10.81,6.4,10.81ZM20,14H16.58a5,5,0,0,1-9.16,0H4v5H20V14m0-2a2.006,2.006,0,0,1,2,2v5a2.006,2.006,0,0,1-2,2H4a2.006,2.006,0,0,1-2-2V14a2.006,2.006,0,0,1,2-2H9a3,3,0,0,0,6,0Z"
            fill="#fd9933"
          />
        </g>
      </svg>
    </div>
  );
}

export default UpcomingSvgComponent;
